export const environment = {
  production: true,
  envName: 'production',
  urls: {
    source: 'https://app.lingueo.com',
    url: 'https://app.lingueo.com',
    module: 'lingueopro',
    default_role: 'student',
    gtagID: 'UA-3750617-18',
    crispID: '25a9f1b2-7904-41a5-953b-62d68f78e7ac',
    sentryDsn: 'https://d0f948a56e8e45e883557f81c6d17dc4@o315478.ingest.us.sentry.io/1795973',
    languages: ['fr', 'en', 'es', 'it'],
    defaultLanguage: 'fr',
    teacher: 'https://teachers.lingueo.com',
    lingueopro: 'https://app.lingueo.com',
    student: 'https://app.lingueo.com',
    backoffice: 'https://manage.lingueo.com',
    lilate: 'https://app.lilate.org',
    exam: 'https://exam.lilate.org',
    elate: 'https://flashlevel.lilate.org/',

  },
  backofficeUrl: 'https://manage.lingueo.com',
  base_server: 'https://api.recurring.lingueo.fr',
  server: 'https://api.recurring.lingueo.fr/api/v1/',
  ws_server: 'wss://api.recurring.lingueo.fr/ws/',
  auth: 'https://api.recurring.lingueo.fr/api/v1/auth/',
  me: 'https://api.recurring.lingueo.fr/api/v1/me/',
  media: 'https://api.recurring.lingueo.fr/media/',
  static: 'https://api.recurring.lingueo.fr/static/',
  salesforce_server: 'https://lingueo.lightning.force.com',
  application_id: 'MX6xlCV4G5at4r31biAN9UG7VyrHggCrUHigyBY1TnrXhqak1xZWLSHETIoAiG9SYDZQqkwFRuUgM39zedn34Kh0itVCX3bfdnJFTjwH0ThUOdbjZqjl6709gXskESpD',
  client_id: 'fHJJ2cPFjzgRkb6ei3mFCLuC6KaLSuySWJbN1abz',
  test: '',
  default_teacher_site: 'https://api.recurring.lingueo.fr/api/v1/sites/2/',
  default_admin_site: 'https://api.recurring.lingueo.fr/api/v1/sites/1/',
  default_student_site: 'https://api.recurring.lingueo.fr/api/v1/sites/4/',
  default_event_rule: 'https://api.recurring.lingueo.fr/api/v1/rules/3/',
  documents: '/api/v1/documents/',
  calendar_export: '/api/v1/calendar/export/',
  maxFileSize: 262144000,
  fileSizeAlert: 'Merci de bien vouloir télécharger un document de moins de 26 mo',
  //aiServer: 'https://d8462bb2-5405-4a87-ad73-f65ddcef80d5.app.gra.ai.cloud.ovh.net/',
  aiServer: 'https://api.elate.lingueo.com/',
};
